import HttpClient from './httpClient';

class UserDocumentsController extends HttpClient {
  getDocumentsForUser = async (token) => {
    const response = await this.client.get('/userDocuments', {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  createDocument = async (document, token) => {
    const response = await this.client.post('/documents', document, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  convertDocument = async (documentId, templateType, token) => {
    const response = await this.client.post(
      `/convertDocument/${documentId}/${templateType}`,
      '',
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };

  /**
   * getDocumentById get's a document by it's ID.
   * @param {string} documentId Id of the document
   * @param {string} token Auth token for Auth header
   * @returns {object} response data
   */

  getDocumentById = async (documentId, token) => {
    const isParentIncluded = false;

    const response = await this.client.get(
      `/documents/${documentId}/${isParentIncluded}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };

  /**
   * updateDocumentById is a function that updates a document data by it's id
   * @param {string} documentId Id of the document
   * @param {object} data Data object to update doc
   * @param {string} token Auth token to go in Auth header
   * @returns {object} response data
   */

  updateDocumentById = async (data, token) => {
    try {
      const resp = await this.client.put(`/updateWiseDocument`, data, {
        headers: {
          Authorization: token,
        },
      });
      return resp;
    } catch (err) {
      throw err;
    }
  };

  checkDocAccess = async (documentId, token) => {
    const response = await this.client.get(`/checkDocAccess/${documentId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  getDocAndNodeById = async (documentId, token) => {
    const isParentIncluded = false;

    const response = await this.client.get(
      `/getDocAndNode/${documentId}/${isParentIncluded}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };
}

export default new UserDocumentsController(
  process.env.REACT_APP_API_BASE_URL_DOCUMENTS,
);
